import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import ModalAssinatura from './ModalAssinatura';

export default function Header({ onMenuOpen, pendentes = 0 }) {
  const navigate = useNavigate();
  const [assinatura, setAssinatura] = useState(null);
  const [modalAberto, setModalAberto] = useState(false);

  useEffect(() => {
    // Cache de 24h para não chamar a cada render
    const cache = sessionStorage.getItem('assinatura_cache');
    if (cache) {
      try {
        const { data, ts } = JSON.parse(cache);
        if (Date.now() - ts < 86400000) { // 24h
          setAssinatura(data);
          return;
        }
      } catch {}
    }
    api.getAssinatura().then(data => {
      setAssinatura(data);
      sessionStorage.setItem('assinatura_cache', JSON.stringify({ data, ts: Date.now() }));
    }).catch(() => {});
  }, []);

  const atualizarAssinatura = () => {
    api.getAssinatura().then(data => {
      setAssinatura(data);
      sessionStorage.setItem('assinatura_cache', JSON.stringify({ data, ts: Date.now() }));
    }).catch(() => {});
  };

  const badge = () => {
    if (!assinatura) return null;
    const { status, diasRestantes, plano } = assinatura;
    const nomePlano = plano || 'Básico';
    if (status === 'TRIAL') {
      return { linhas: ['Grátis', `${diasRestantes} dia(s)`, 'restantes'], cor: diasRestantes <= 5 ? '#975a16' : '#2b6cb0', bg: diasRestantes <= 5 ? '#fefcbf' : '#ebf8ff' };
    }
    if (status === 'ATIVO') {
      if (diasRestantes <= 5) return { linhas: [nomePlano, `Vence em`, `${diasRestantes} dia(s)`], cor: '#975a16', bg: '#fefcbf' };
      return { linhas: [nomePlano, 'Ativo', ''], cor: '#276749', bg: '#f0fff4' };
    }
    // Só anuncia vencimento quando o servidor disse VENCIDO. Uma resposta
    // inesperada não pode virar "Vencido / Clique para pagar" na cara do produtor.
    if (status === 'VENCIDO') {
      return { linhas: [nomePlano, 'Vencido', 'Clique para pagar'], cor: '#c53030', bg: '#fff5f5' };
    }
    return null;
  };

  const b = badge();

  return (
    <>
      {modalAberto && assinatura && <ModalAssinatura assinatura={assinatura} onClose={() => setModalAberto(false)} />}
      <header className="app-header">
        <button
          className="hamburger"
          onClick={onMenuOpen}
          aria-label={pendentes > 0 ? `Abrir menu. ${pendentes} notificação(ões) não lida(s)` : 'Abrir menu'}
          aria-haspopup="dialog"
          aria-controls="menu-principal"
        >
          <span aria-hidden="true">☰</span>
          {pendentes > 0 && <span className="hamburger-badge" aria-hidden="true">{pendentes}</span>}
        </button>
        <button className="header-brand" onClick={() => navigate('/')}>
          <span className="marca-icone marca-icone--sm" aria-hidden="true">
            <img src={process.env.PUBLIC_URL + '/icone-sem-fundo.png'} alt="" />
          </span>
          <span className="header-brand-name">AgriGest</span>
        </button>
        {b && (
          <button
            onClick={() => { atualizarAssinatura(); setModalAberto(true); }}
            aria-label={`Assinatura: ${b.linhas.filter(Boolean).join(', ')}. Ver detalhes`}
            style={{
              marginLeft: 'auto', padding: '0.2rem 0.6rem',
              background: b.bg, border: `1px solid ${b.cor}30`, borderRadius: '8px',
              color: b.cor, fontSize: '0.62rem', fontWeight: 600,
              cursor: 'pointer', minHeight: 'unset', boxShadow: 'none',
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              lineHeight: 1.3, gap: '0'
            }}
          >
            <span style={{ fontSize: '0.68rem', fontWeight: 700 }}>{b.linhas[0]}</span>
            {b.linhas[1] && <span>{b.linhas[1]}</span>}
            {b.linhas[2] && <span style={{ fontSize: '0.58rem', fontWeight: 500 }}>{b.linhas[2]}</span>}
          </button>
        )}
      </header>
    </>
  );
}
